/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import {
  compareArrays,
  empty,
  errorResponse,
  isArray,
  prepareResponseData,
} from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";

// api
import schoolApi from "../../api/School";

// hooks
import { AuthContext } from "../Root/ProtectedRoute";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import FullPageLoader from "../../components/loader/FullPageLoader";
import InputField from "../../components/form/InputField";
import AppCheckbox from "../../components/form/AppCheckbox";
import { yesNo } from "../../data/yesNo";
import SelectField from "../../components/form/SelectField";

const required = "This field is required!";
const validationSchema = Yup.object().shape({
  title: Yup.string().required(required),
});

const AddUpdateUserGroup = ({ ...props }) => {
  const [initialValues, setInitialValues] = useState({
    title: "",
    active: "",
  });
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [userGroupLoading, setUserGroupLoading] = useState(true);
  const { userGroupId } = useParams();
  const toastTR = useRef(null);
  const [authorizations, setAuthorizations] = useState([]);
  const [allItemsChecked, setAllItemsChecked] = useState(false);
  const [staffRoles, setStaffRoles] = useState([]);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (userGroupId) {
      getUserGroupDetails();
    }
  }, [userGroupId]);

  useEffect(() => {
    setStaffRoles(user?.staffRoles || []);
  }, [user?._id]);

  useEffect(() => {
    const allSelected = compareArrays(staffRoles, authorizations);
    if (allSelected) {
      setAllItemsChecked(true);
    }
  }, [authorizations, staffRoles]);

  const onAuthorizationChange = (e) => {
    try {
      const selectedTitle = e.target.value;
      const selectedItem = staffRoles.find(
        (item) => item.title === selectedTitle
      );

      setAuthorizations((prev) => {
        const isSelected = prev.some((item) => item?.title === selectedTitle);
        return isSelected
          ? prev.filter((item) => item?.title !== selectedTitle)
          : [...prev, selectedItem];
      });
    } catch (error) {}
  };

  const onToggleAllRoles = () => {
    if (!allItemsChecked) {
      setAuthorizations(staffRoles);
    } else {
      setAuthorizations([]);
    }
    setAllItemsChecked(!allItemsChecked);
  };

  const getUserGroupDetails = async () => {
    if (!userGroupLoading) setUserGroupLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getUserGroupDetails(
        schoolId,
        userGroupId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }

      if (!empty(response_data) && !empty(response_data.response)) {
        const userGroupDetails = response_data.response;
        setInitialValues({
          title: !empty(userGroupDetails.title) ? userGroupDetails.title : "",
          active: !empty(userGroupDetails.active)
            ? userGroupDetails.active
            : false,
        });
        setAuthorizations(
          !empty(userGroupDetails.authorizations) &&
            isArray(userGroupDetails.authorizations)
            ? userGroupDetails.authorizations
            : []
        );
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setUserGroupLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    if (!isLoading) setIsLoading(true);
    try {
      if (empty(values)) {
        return responseDialog(
          "error",
          "Error Alert",
          "Something went wrong! Try again later."
        );
      }
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const title = !empty(values["title"]) ? values["title"] : "";
      const active = !empty(values["active"]) ? values["active"] : "";
      let response;
      let userGroupAdded = false;
      let userGroupUpdated = false;
      if (!userGroupId) {
        response = await schoolApi.addUserGroup(
          schoolId,
          title,
          active,
          authorizations
        );
        userGroupAdded = true;
      } else {
        response = await schoolApi.updateUserGroup(
          schoolId,
          userGroupId,
          title,
          active,
          authorizations
        );
        userGroupUpdated = true;
      }
      const response_data = prepareResponseData(response);
      if (empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      }

      navigate("/user-groups", {
        state: { userGroupAdded, userGroupUpdated },
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          <div className="container flex-center-top">
            <MainHeader
              title={
                !empty(userGroupId) ? "Update User Group" : "Add User Group"
              }
            />
            <div className="form-container mt-30">
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, handleChange }) => (
                  <Form style={{ width: "100%" }}>
                    <div>
                      <em>
                        <strong>Note: *</strong> Please enter the correct
                        details for the classs
                      </em>
                    </div>
                    <div className="app_input_group mb-50">
                      <InputField
                        placeholder="Enter Class Title"
                        name="title"
                        height={50}
                        labelTitle="Title"
                        required={true}
                      />
                    </div>

                    <MainHeader title="Authorizations" />
                    <div>
                      <AppCheckbox
                        value="All"
                        style={{ marginBottom: 20 }}
                        onChange={onToggleAllRoles}
                        checked={allItemsChecked}
                        width="w-25pc"
                      />
                    </div>
                    {isArray(staffRoles) && !empty(staffRoles)
                      ? // Convert the flat array into groups of 4
                        Array(Math.ceil(staffRoles.length / 4))
                          .fill()
                          .map((_, rowIndex) => (
                            <div
                              key={`row-${rowIndex}`}
                              className="flex flex-wrap justify-content-center gap-3 w-100p mb-20"
                            >
                              {staffRoles
                                .slice(rowIndex * 4, (rowIndex + 1) * 4)
                                .map((item, itemIndex) => {
                                  const globalIndex = rowIndex * 4 + itemIndex;
                                  return (
                                    <AppCheckbox
                                      key={globalIndex}
                                      index={globalIndex}
                                      value={item?.title}
                                      width="w-25pc"
                                      onChange={onAuthorizationChange}
                                      checked={authorizations.some(
                                        (auth) => auth?.title === item?.title
                                      )}
                                    />
                                  );
                                })}
                            </div>
                          ))
                      : ""}

                    <div className="app_input_group mb-50 md-w-50pc">
                      <SelectField
                        labelTitle="Activate User Group"
                        placeholder="Activate this User Group?"
                        name="active"
                        required={true}
                        options={yesNo}
                        height={50}
                        valueKey="active"
                        selectedOption={values.active}
                        handleChangeFunc={handleChange}
                      />
                    </div>
                    <div className="form-button-container">
                      <ButtonIcon
                        height={45}
                        marginTop={5}
                        color="#ffffff"
                        backgroundColor="#633ccd"
                        width={300}
                        borderColor="#633ccd"
                        buttonText={
                          userGroupId ? "Update User Group" : "Add User Group"
                        }
                        type="submit"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </AppWrapper>
    </>
  );
};

export default AddUpdateUserGroup;
